<script lang="ts">
  export let description: string = '';
</script>

{#if description}
    <p class="store-description">
      {description}
    </p>
  {/if}

<style lang="scss">
  .store-description {
    font-size: inherit;
    font-family: inherit;
    color: inherit;
    font-weight: inherit;
  }
</style> 